export default __webpack_public_path__ + "static/media/safari.2b03afad.svg";